import classNames from 'classnames';

type Props = {
    adjustgridheight?: boolean;
    heighttablet?: string;
    heightdesktop?: string;
    className?: string;
    classes?: string;
    width?: string;
    backgroundcolor?: string;
    hascoldividers?: boolean;
};

const Grid = ({
    adjustgridheight = false,
    heighttablet,
    heightdesktop,
    children,
    className,
    classes,
    width = 'max-w-screen-xl',
    backgroundcolor,
    hascoldividers,
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={classNames(
                'grid-wrapper',
                'mx-auto w-full h-full',
                width,
                backgroundcolor,
                adjustgridheight && heightdesktop && heighttablet && heightdesktop + heighttablet
            )}
        >
            <div
                className={classNames(
                    classes,
                    'grid col-gap-4 grid-cols-4 md:gap-6 md:grid-cols-8 lg:grid-cols-12',
                    'px-4 md:px-6 lg:px-0',
                    'h-full lg:max-w-screen-xl mx-auto',
                    hascoldividers && 'py-6',
                    className
                )}
            >
                {children}
            </div>
        </div>
    );
};

export default Grid;
